function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.35907 9.86812L11.8592 6.73073C12.1647 6.45685 11.9403 6 11.5001 6H4.49987C4.05975 6 3.83526 6.45685 4.1408 6.73073L7.64093 9.86812C7.83711 10.044 8.16289 10.044 8.35907 9.86812Z"
});
function SvgArrowDownDropdown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownDropdown);
export default __webpack_public_path__ + "static/media/arrow-down-dropdown.c4782f5c.svg";
export { ForwardRef as ReactComponent };